const apiName = process.env.BUILD_ENV === 'dev' ? 'ec-pc-api' : 'ec-pc-api'
const dataImport = {
  deliverySelectShippingArea: {
    type: 'post',
    url: `${apiName}/order/delivery/selectShippingArea`
  },
  infoListPage: { //非销查询
    type: 'post',
    url: `/ec-pc-api/import/unsaleOrder/info/listPage`
  },
  listOrderNoPage: { //非销订单记录查询
    type: 'post',
    url: `/ec-pc-api/import/unsaleOrder/info/listOrderNoPage`
  },
  addUnsaleOrder: { //非销订单新增
    type: 'post',
    url: `/ec-pc-api/import/unsaleOrder/info/addUnsaleOrder`
  },
  UpdaUnsaleOrder: { //非销订单编辑
    type: 'post',
    url: `/ec-pc-api/import/unsaleOrder/info/UpdaUnsaleOrder`
  },
 unsaleOrderStatus: { //非销订单-订单状态下拉列表
    type: 'get',
    url: `/ec-pc-api/import/unsaleOrder/info/order/status`
  },
  unsaleOrderType: { //非销订单-订单状态下拉列表
    type: 'get',
    url: `/ec-pc-api/import/unsaleOrder/info/order/type`
  },
  batchAddUnsaleOrder: { //非销订单-批量新增
    type: 'post',
    url: `/ec-pc-api/import/unsaleOrder/info/batchAddUnsaleOrder`
  },
  customizedCustomers: { //电商定制客户查询
    type: 'post',
    url: `/ec-pc-api/customizedCustomers/listPage`
  },
  importList: { //店铺提报情况
    type: 'post',
    url: `/ec-pc-api/pre-sale/plan/planAdjust/importList`
  },
  importTotal: { //店铺提报数量
    type: 'get',
    url: `/ec-pc-api/pre-sale/plan/planAdjust/importTotal`
  },
  refresh: { //非销订单-订单状态刷新
    type: 'get',
    url: `/ec-pc-api/import/unsaleOrder/info/order/refresh`
  },
  //出库时间导入
  shortagePackImport: {
    type: 'post',
    url: `/ec-fast-propose-api/local/import/shortagePackImport`
  },
  //缺货包件导入记录
  packImportRecord: {
    type: 'post',
    url: `/ec-pc-api/shortage/pack/importRecord`
  },
  //缺货包件导入模版下载
  shortagePackDow: {
    type: 'post',
    url: `/ec-fast-propose-api/local/import/shortagePackDow`
  },
  //拍摄类型导入动态分页
  shootingTypeSearch: {
    type: 'post',
    url: `/ec-pc-api/newProductArrival/shootingType/all/search`
  },
  //拍摄类型导入动态分页-导出
  shootingTypeExport: {
    type: 'post',
    url: `/ec-pc-api/newProductArrival/shootingType/all/export`
  },
  //拍摄类型-编辑
  shootingTypeUpdate: {
    type: 'post',
    url: `/ec-pc-api/newProductArrival/shootingType/all/update`
  },
  //拍摄类型-动态列导入
  shootingTypeInfoImport: {
    type: 'post',
    url: `/ec-pc-api/customize/import/newProduct/shootingTypeInfo`
  },
  //导入拼多多-商品价格信息
  pddGoodsPriceInfo: {
    type: 'post',
    url: `/ec-pc-api/customize/import/pdd/goodsPriceInfo`
  },
  //导入拼多多-手动拉取官方价格信息
  pddOfficialInfo: {
    type: 'get',
    url: `/ec-pc-api/pddGoodsPrice/pull/officialInfo`
  },
  //不考核商品-新增
  unAssessGoodsAdd: {
    type: 'post',
    url: `/ec-pc-api/pre-sale/plan/unAssessGoods/add`
  },
  //不考核商品-删除
  unAssessGoodsDel: {
    type: 'post',
    url: `/ec-pc-api/pre-sale/plan/unAssessGoods/del`
  },
  //不考核商品-分页
  unAssessGoodsSearch: {
    type: 'post',
    url: `/ec-pc-api/pre-sale/plan/unAssessGoods/search`
  },



  // 导入记录分页查询
  fileListPage: {
    type: 'post',
    url: `${apiName}/file/listPage`
  },
  // 导入
  uploadFile:{
    type: 'upload', // 自定义类型，实际为post
    url: `ec-file-api/file/upload`
  },
  // 中奖名单删除
  activityDel:{
    type: 'get',
    url: `${apiName}/activity/del`
  },
  // 限售分类配置信息
  getConfigInfoStr:{
    type: 'post',
    url: `${apiName}/jd/restricted/getConfigInfoStr`
  },
  // 删除限售分类配置
  restrictedDel:{
    type: 'get',
    url: `${apiName}/jd/restricted/del`
  },
  // 限售分类配置信息分页查询
  getConfigInfoPage:{
    type: 'post',
    url: `${apiName}/jd/restricted/getConfigInfoPage`
  },
  // 保存编辑限售分类配置
  saveOrUpdateRestrictedConfig:{
    type: 'post',
    url: `${apiName}/jd/restricted/saveOrUpdateRestrictedConfig`
  },
  // sku分页信息
  skuListPage:{
    type: 'post',
    url: `${apiName}/jd/restricted/skuListPage`
  },
  // 删除京东SKU限售分类
  deleteJdSKU: {
    type: 'get',
    url: `${apiName}/jd/restricted/deleteJdSKU`
  },
  // 编辑京东SKU限售分类
  updateJdSKU: {
    type: 'get',
    url: `${apiName}/jd/restricted/updateJdSKU`
  },
  // sku京东查询结果分页信息
  skuQueryList:{
    type: 'post',
    url: `${apiName}/jd/restricted/skuQueryList`
  },
}

export default dataImport;
